export default class PostFileClick {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.postFileUrl = rawData.postFileUrl
      this.countOfClicked = rawData.countOfClicked
      this.name = rawData.name
      this.creationDate = rawData.creationDate
    }
  }